import { cdnUrl, withAssetCacheVersion } from '../utils/assetCache';
export const STATIC_ASSET_BASE = '/static';

/** Paths that live at site root (not under /static/). */
function isRootServedPath(pathname) {
  return (
    pathname.startsWith('/uploads/')
    || pathname.startsWith('/digitech/')
    || pathname.startsWith('/api/')
  );
}

export function staticAsset(path) {
  if (!path) return '';
  if (/^https?:\/\//i.test(path) || path.startsWith('data:')) return path;
  let normalized = path.startsWith('/') ? path : `/${path}`;
  if (isRootServedPath(normalized)) {
    // /uploads → Bunny (cdnUrl); /digitech + /api stay origin-relative.
    return withAssetCacheVersion(normalized);
  }
  if (!normalized.startsWith('/static/')) {
    normalized = `${STATIC_ASSET_BASE}${normalized}`;
  }
  return withAssetCacheVersion(normalized);
}

export function resolveCmsIconUrl(url) {
  if (!url) return null;
  if (/^https?:\/\//i.test(url) || url.startsWith('data:')) {
    return withAssetCacheVersion(url);
  }
  if (url.startsWith('/uploads/') || url.startsWith('/digitech/')) {
    return withAssetCacheVersion(url);
  }
  return staticAsset(url);
}
